module.exports = __webpack_public_path__ + "img/卡卡城堡.fd2a80cd.png";